module.exports = __webpack_public_path__ + "img/share.9a372558.png";